import React from 'react';

import Button from '../common/Button/Button';

import { TestID } from '../../testID';

import './PipeInput.css';

export const ExternalSourceEntities: React.FC<{
  setFetchRemoteEntities: (val: boolean) => void;
}> = ({ setFetchRemoteEntities }) => (
  <div data-testid={TestID.PipeInputExternalSourceEntities} className="pipe-input">
    <div className="pipe-input__description">
      <h1 className="heading-page">Input entities</h1>
      <p className="output-">
        This pipe has an external source and loading the input entities will trigger a network
        request to the source system
      </p>
    </div>
    <div className="pipe-input__content">
      <div className="pipe-input__content-section">
        <Button theme="primary" onClick={() => setFetchRemoteEntities(true)}>
          Fetch entities
        </Button>
      </div>
    </div>
  </div>
);
